(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tinto-option2-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';
    function initPdp(root) {
      if (root.dataset.option2VariantReady) return;
      root.dataset.option2VariantReady = 'true';
      const radios = [...root.querySelectorAll('[data-option2-variant]')];
      const id = root.querySelector('[data-option2-variant-id]');
      const quantity = root.querySelector('[data-option2-quantity]');
      const price = root.querySelector('[data-option2-price]');
      const button = root.querySelector('.o2-pdp__add');
      const status = root.querySelector('[data-option2-status]');
      const form = root.querySelector('[data-option2-form]');
      const clearStatus = () => {
        if (!status) return;
        status.textContent = '';
        status.hidden = true;
      };
      radios.forEach((radio) => radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (id) id.value = radio.dataset.variantId || '';
        if (quantity) quantity.value = '1';
        if (price) price.textContent = radio.dataset.price || '';
        radios.forEach((item) => item.closest('label')?.classList.toggle('is-selected', item === radio));
        if (button) button.disabled = radio.dataset.available !== 'true';
        clearStatus();
        id?.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      form?.addEventListener('submit', (event) => {
        if (id?.value && quantity?.value === '1' && !button?.disabled) return;
        event.preventDefault();
        if (status) {
          status.textContent = 'No pudimos confirmar la presentación. Selecciónala de nuevo e inténtalo otra vez.';
          status.hidden = false;
          status.focus?.({ preventScroll: true });
        }
      });
    }
    function init(scope = document) {
      scope.querySelectorAll?.('[data-option2-pdp]').forEach(initPdp);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
